import { LoadingState } from '@lcs/shared/api';
import { createFeatureSelector, on } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { RegisterState } from 'src/app/common-components/register/models/register-state';
import {
   RegisterAdapter,
   createRegisterAdapter,
} from 'src/app/common-components/register/models/register-state.adapter';
import { PhoneRegisterOptions } from '../../models/phone-register-options';
import { PhoneRegisterListItem } from '../../models/phone-register-results.model';
import * as phoneRegisterActions from './phone-register.actions';

export const phoneRegisterFeatureKey = 'phoneRegister';
export type PhoneRegisterState = RegisterState<PhoneRegisterListItem, PhoneRegisterOptions, OrderingOption>;

const adapter: RegisterAdapter<PhoneRegisterListItem, PhoneRegisterOptions, OrderingOption> = createRegisterAdapter<
   PhoneRegisterListItem,
   PhoneRegisterOptions,
   OrderingOption
>({
   selectId: (phoneRegisterItem) => {
      return phoneRegisterItem.phoneId ?? 0;
   },
});

const initialState: PhoneRegisterState = {
   ...adapter.getInitialState(),
};

export const phoneRegisterReducer = adapter.createReducer(
   phoneRegisterActions.phoneRegisterAdapterActions,
   initialState,
   on(phoneRegisterActions.phoneRegisterAdapterActions.pageEnter, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(phoneRegisterActions.phoneRegisterAdapterActions.loadSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         phones: action.items,
         endCursor: action.endCursor,
         hasNextPage: action.hasNextPage,
         totalCount: action.totalCount,
      };
   })
);
export const phoneRegisterSelector = createFeatureSelector<PhoneRegisterState>(phoneRegisterFeatureKey);
export const selectors = adapter.getSelectors(phoneRegisterSelector);
export const { selectAll, selectCallState, selectTotalCount, selectEndCursor } =
   adapter.getSelectors(phoneRegisterSelector);
